/**
 * Wallpapers for the login split panel.
 *
 * Files live in `public/login_bg/`. Add a filename here to put it in rotation —
 * the panel picks one per page load, so the product feels alive without any
 * motion that would distract from the form.
 *
 * Kept in a module (not read from disk) because `public/` is served verbatim
 * and never enumerated at build time.
 */
export const LOGIN_WALLPAPERS = ['/login_bg/bg1.png', '/login_bg/bg2.png'];

export function pickWallpaper(): string {
  const i = Math.floor(Math.random() * LOGIN_WALLPAPERS.length);
  return LOGIN_WALLPAPERS[i] ?? LOGIN_WALLPAPERS[0];
}
